import { Component } from "@mzw/component";
import { sectionRenderer } from "@mzw/section-renderer";
import { tracking } from "@mzw/tracking";
import { requestYieldCallback, startViewTransition } from "@mzw/utils";

/**
 * Sort-by component for collection/search page sorting.
 * Works with `<select>`, `<details>`, and `<disclosure-component>` variants.
 */
export class ComponentSortBy extends Component {
	/** @returns {string} The section ID for rendering */
	get sectionId() {
		const id = this.getAttribute("section-id");
		if (!id) throw new Error("Section ID is required");
		return id;
	}

	/**
	 * Handles sort option change
	 * @param {Event} event - Change event from select or radio input
	 */
	onChange = async (event) => {
		const trigger = event.target;
		const productGrid = document.querySelector(".product-grid");
		productGrid?.classList.add("loading");

		const sortByValue = trigger.value;
		const url = new URL(globalThis.location.href);

		url.searchParams.set("sort_by", sortByValue);
		url.searchParams.set("section_id", this.sectionId);

		const urlWithoutSectionId = new URL(url);
		urlWithoutSectionId.searchParams.delete("section_id");

		requestYieldCallback(() => {
			globalThis.history.replaceState({}, "", urlWithoutSectionId.toString());
		});

		try {
			await startViewTransition(
				() => sectionRenderer.renderSection(this.sectionId),
				["product-grid"],
			);
		} finally {
			productGrid?.classList.remove("loading");
			// Close dropdown if present (supports details and disclosure-component variants)
			this.querySelector("details")?.removeAttribute("open");
			this.querySelector("disclosure-component")?.hide();
			// Restore focus to the trigger element
			trigger.focus();
		}

		tracking.event("Sort By", { sort_by: sortByValue });
	};
}

if (!customElements.get("component-sort-by")) {
	customElements.define("component-sort-by", ComponentSortBy);
}
